import { Line } from 'recharts';
import { ChartSeries } from '../types';
import { DeltaRow, FAN_NEVER_OFF_MESSAGE } from './transitionDeltaSeries';

interface Props {
  series: ChartSeries[];
  rows: DeltaRow[];
}

export const renderDeltaMarkerLines = ({ series, rows }: Props) =>
  series.filter((item) => rows.some((row) => typeof row[`hollow_${item.id}`] === 'number')).map((item) => (
    <Line
      key={`hollow_${item.id}`}
      type="linear"
      dataKey={`hollow_${item.id}`}
      yAxisId="left"
      stroke="none"
      dot={{
        fill: 'var(--background)', stroke: item.color, strokeWidth: 2, r: 5,
        role: 'img', 'aria-label': `${item.label}: ${FAN_NEVER_OFF_MESSAGE}`,
      }}
      activeDot={false}
      legendType="none"
      isAnimationActive={false}
    />
  ));
